/**
 * Código que o servidor anexa ao erro de handshake quando a recusa foi de
 * **autenticação**, não de rede.
 *
 * Existe porque o cliente não tem outra forma de separar as duas coisas: um
 * `connect_error` de token expirado chega igual a um de servidor fora do ar, e os
 * sockets deste projeto reconectam com `reconnectionAttempts: Infinity`. Sem o
 * código, sessão expirada vira reconexão silenciosa para sempre — no meio de um
 * atendimento a consulta deixa de ser transcrita e nada diz o motivo.
 *
 * Fica em `shared/` porque é contrato entre os dois lados (o servidor grava em
 * `err.data.code`, o frontend lê). Uma cópia literal de cada lado divergiria sem
 * ninguém perceber.
 */
export const SOCKET_AUTH_FAILED_CODE = 'SOCKET_AUTH_FAILED';

/**
 * Código do handshake recusado porque o servidor NÃO CONSEGUIU validar a sessão (banco
 * fora, timeout) — o oposto de `SOCKET_AUTH_FAILED`. Com o código de recusa, uma
 * oscilação do Postgres deslogava o médico no meio da consulta; com este, o cliente
 * tenta de novo. Precisa ser explícito: o Socket.IO destrói o socket em qualquer erro de
 * middleware, e sem o cliente religar à mão a transcrição parava em silêncio.
 */
export const SOCKET_AUTH_UNAVAILABLE_CODE = 'SOCKET_AUTH_UNAVAILABLE';
